import { Pipe, PipeTransform } from '@angular/core';
import { FormatNumberHelper } from '@core/helpers/format-number.helper';

@Pipe({
    name: 'formatNumber',
    standalone: false
})
export class FormatNumberPipe implements PipeTransform {
  transform(value: string | number, property: string): string {
    return FormatNumberHelper.formatByProperty(value, property);
  }
}
